<template>
  <div id="showroom-products">
    <div class="wrapper" v-if="!loadingApp">
      <section class="team-sports">
        <div class="sport-cards-container">
          <CatalogCards @fetchingLoading="handleFetchingLoading" />
        </div>
      </section>
      <section class="team-sports">
        <label class="sidebar-option-title"
          >Choose Product Types To Include</label
        >
        <div class="gender-options">
          <div class="radio-container">
            <input
              id="gender-men"
              type="checkbox"
              name="gender[]"
              v-model="gender"
              value="men"
            />

            <label for="gender-men">Men's </label>
          </div>

          <div class="radio-container">
            <input
              id="gender-women"
              type="checkbox"
              name="gender[]"
              v-model="gender"
              value="women"
            />

            <label for="gender-women">Women's </label>
          </div>
        </div>
        <div></div>
      </section>
      <section class="path-navigation">
        <div class="navigation-divider">&nbsp;</div>
        <div class="path-actions">
          <div class="path-hint">NEXT STEP</div>
          <div
            class="path-action"
            :class="{
              'path-action-disabled': !hasCatalogsSelected || fetchingLoading,
            }"
            @click="handleAction()"
          >
            VISIT YOUR SHOWROOM
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.5625 5.25L19.3125 12L12.5625 18.75"
                stroke="#FFFFFF"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M18.375 12H4.6875"
                stroke="#FFFFFF"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </section>
    </div>
    <div class="loader-container" v-else>
      <Loader />
    </div>
  </div>
</template>

<script>
import CatalogCards from "@/components/Projects/Showrooms/CatalogCards";
import Loader from "@/components/Utils/Loader";

import { mapActions, mapState } from "vuex";

export default {
  name: "ShowroomProducts",

  computed: {
    ...mapState("catalog", ["catalogsData"]),
    ...mapState("showroom", ["selectedCatalogs"]),

    catalogueURL() {
      return this.hasCatalogsSelected
        ? `/showrooms/${this.$route.params.dealer_code}/catalogue`
        : "#";
    },

    hasCatalogsSelected() {
      return this.selectedCatalogs?.length > 0;
    },
  },

  methods: {
    ...mapActions("showroom", ["setHomepageGender"]),
    ...mapActions("catalog", ["getProductsCatalogs"]),

    handleAction() {
      if (!this.hasCatalogsSelected || this.fetchingLoading) return false;

      this.loadingApp = true;
      setTimeout(() => {
        this.setHomepageGender(this.gender);
        this.$router.push(this.catalogueURL);
      }, 100);
    },
    /* calcSelectedCatalog(sportName) {
      console.log("sportName", sportName);
      const index = this.selectedCatalogs?.indexOf(sportName);
      if (index >= 0) {
        this.selectedCatalogs.splice(index, 1);
      } else {
        this.selectedCatalogs.push(sportName);
      }
    },*/

    handleFetchingLoading(payload) {
      this.fetchingLoading = payload;
    },
  },

  components: {
    CatalogCards,
    Loader,
  },

  data() {
    return {
      catalogs: [],
      gender: ["men", "women"],
      fetchingLoading: false,
      loadingApp: false,
    };
  },

  async mounted() {
    await this.getProductsCatalogs();
    this.catalogs = this.catalogsData
      .map((item) => item.catalogName)
      .filter((value, index, self) => self.indexOf(value) === index);
    console.log("this.catalogs", this.catalogs);
    //this.calcSelectedCatalog();
    this.$emit("updatePersonalizationsTab", "products");
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .team-sports {
    width: 70%;
    margin: 1em 0;

    .gender-options {
      display: flex;
      align-items: center;

      .radio-container {
        display: flex;
        align-items: center;
        > label {
          margin: 0 0.5em;
          cursor: pointer;
        }
        > input {
          cursor: pointer;
        }
      }
    }
  }
}
</style>